import { PRODUCT_CONFIG } from 'src/app/_common/product-config';
import { ThirdPartyNames } from '../_common/_enum/module.enum';

export class EventLogging {
    channelName: string = null;
    psoUser: string = null;
    userSessionId: string = null;
    eventType: string = null;
}

export class DnBEventLog extends EventLogging {
    flowSessionId: string = null;
    thirdPartyName: string = ThirdPartyNames.DNB;
    thirdPartyTransId: string = null;
    niche: string = null;
    producer: number = null;
    maxResultCount: number = PRODUCT_CONFIG.maxDnbExpectedResultCount;
    returnResultCount: number = null;
    inCompleteResultCount: number = null;
    searchTerm: string = null;
    choiceIndex: number = 0;
    choice: any = null;
    filterCriteria: any = {
        countryISOAlpha2Code: "US",
        addressRegion: null,
        isOutOfBusiness: false
    };
    results: any = [];
    accountNumber: number = null;
}


